import requestWrapper, {sortParams} from '../../requestWrapper';
import endpoints from './endpoints';
import type {
	Campaign,
	CampaignBudgetRange,
	CampaignCreate,
	CampaignEdit,
	CampaignStatuses,
} from './types';
import type {DataResponseWrapper} from '@deezer/next/services/api/Starmania/requests/types';
import type {CampaignActiveFilterType} from '@deezer/next/features/CampaignManager/types';
import {notNull} from '@deezer/next/shared/utils/array';
import type {StakeholderType} from '@deezer/next/services/api/Starmania/requests/album/types';

const {get, paginatedGet, post, patch} = requestWrapper;

const requests = {
	getCampaigns: (filters?: CampaignActiveFilterType) => {
		return paginatedGet<Campaign[]>(
			endpoints.campaigns,
			sortParams(filters?.sort, filters?.sortOrder, {
				params: {
					providerIds: filters?.providers?.map(i => i.id)?.filter(notNull),
					statuses: filters?.statuses,
					countries: filters?.countries,
					startRunDate: filters?.startRunDate || undefined,
					endRunDate: filters?.endRunDate || undefined,
				},
			}),
		);
	},
	getCampaign: (id: number) => {
		return get<DataResponseWrapper<Campaign>>(endpoints.campaign(id));
	},
	editCampaign: (id: number, data: CampaignEdit) => {
		return patch<DataResponseWrapper<Campaign>>(endpoints.campaign(id), data);
	},
	deleteCampaign: (id: number) => requestWrapper.delete(endpoints.campaign(id)),
	rejectCampaign: (id: number, rejectReason: string) =>
		patch(endpoints.denyCampaign(id), {rejectReason}),
	updateCampaignStatus: (id: number, status: CampaignStatuses) =>
		patch(endpoints.campaignStatus(id), {status}),
	getImpressionsPerBudget: (
		budget: number,
		stakeholderType?: StakeholderType,
		stakeholderId?: number,
	) =>
		get<DataResponseWrapper<{impressions: number}>>(endpoints.impressions, {
			params: {
				budget,
				stakeholderType,
				stakeholderId,
			},
		}),
	create: (data: CampaignCreate) =>
		post<DataResponseWrapper<{message: string; campaignId: number}>>(
			endpoints.campaigns,
			data,
		),
	getBudgetRange: (providerId?: number, labelId?: number) =>
		get<DataResponseWrapper<CampaignBudgetRange>>(endpoints.budgetRange, {
			params: {
				providerId,
				labelId,
			},
		}),
};

export default requests;
